import React, { Component } from 'react';
import PaymentInstrumentDocumentShowActions from './PaymentInstrumentDocumentShowActions';
import { FileField, BooleanField, DateField, Show, TextField } from 'react-admin';
import Grid from '../../components/wrapper/Grid';
import GridShowLayout from '../../components/wrapper/GridShowLayout';
import { LinkField } from '../../components/fields';

class PaymentInstrumentDocumentShow extends Component {
	render() {
		return (
			<Show {...this.props} actions={<PaymentInstrumentDocumentShowActions />}>
				<GridShowLayout>
					<Grid container>
						<Grid item xs>
							<TextField source="id" />
							<TextField source="originalFileName" />
							<DateField source="creationDateTime" showTime />
							<TextField source="fileContentType" />
							<TextField source="fileSizeBytes" />
						</Grid>
						<Grid item xs>
							<LinkField source="paymentInstrumentId" type="PaymentInstrument" />
							<TextField source="paymentInstrumentType" />
							<LinkField source="owner" type="User" />
							<TextField source="qualifier" />
							<BooleanField source="verified" />
							<DateField source="verificationDateTime" showTime />
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xl>
							<FileField source="links.content" title="originalFileName" />
						</Grid>
					</Grid>
				</GridShowLayout>
			</Show>
		);
	}
}

export default PaymentInstrumentDocumentShow;
